import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as PropTypes from "prop-types";
import { SearchkitComponent, CheckboxFilterAccessor, renderComponent } from "../../../../core";
import { Panel, CheckboxItemList } from "../../../ui";

var defaults = require("lodash/defaults");

export var CheckboxFilter =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(CheckboxFilter, _SearchkitComponent);

  function CheckboxFilter(props) {
    var _this;

    _classCallCheck(this, CheckboxFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CheckboxFilter).call(this, props));
    _this.toggleFilter = _this.toggleFilter.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CheckboxFilter, [{
    key: "defineAccessor",
    value: function defineAccessor() {
      var _this$props = this.props,
          id = _this$props.id,
          title = _this$props.title,
          translations = _this$props.translations,
          label = _this$props.label,
          filter = _this$props.filter;
      return new CheckboxFilterAccessor(id, {
        id: id,
        title: title,
        label: label,
        translations: translations,
        filter: filter
      });
    }
  }, {
    key: "toggleFilter",
    value: function toggleFilter() {
      this.accessor.state = this.accessor.state.create(!this.accessor.state.getValue());
      this.searchkit.performSearch();
    }
  }, {
    key: "setFilters",
    value: function setFilters(keys) {
      this.accessor.state = this.accessor.state.setValue(keys.length > 0);
      this.searchkit.performSearch();
    }
  }, {
    key: "getSelectedItems",
    value: function getSelectedItems() {
      if (this.accessor.state.getValue()) {
        return [this.props.label];
      } else {
        return [];
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.accessor) return null;
      var _this$props2 = this.props,
          listComponent = _this$props2.listComponent,
          containerComponent = _this$props2.containerComponent,
          showCount = _this$props2.showCount,
          title = _this$props2.title,
          id = _this$props2.id,
          label = _this$props2.label;
      var disabled = this.searchkit.getHitsCount() == 0 && !this.accessor.state.getValue();
      return renderComponent(containerComponent, {
        title: title,
        className: id ? "filter--".concat(id) : undefined,
        disabled: disabled
      }, renderComponent(listComponent, {
        items: [{
          key: label,
          doc_count: this.accessor.getDocCount()
        }],
        selectedItems: this.getSelectedItems(),
        toggleItem: this.toggleFilter,
        setItems: this.setFilters.bind(this),
        showCount: showCount
      }));
    }
  }]);

  return CheckboxFilter;
}(SearchkitComponent);
CheckboxFilter.propTypes = defaults({
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  filter: PropTypes.object.isRequired,
  translations: SearchkitComponent.translationsPropType(CheckboxFilterAccessor.translations),
  showCount: PropTypes.bool
}, SearchkitComponent.propTypes);
CheckboxFilter.defaultProps = {
  listComponent: CheckboxItemList,
  containerComponent: Panel,
  collapsable: false,
  showCount: true
};